export class PremierServiceTypeDTO{
    public id!: string;
    public name!: string;
}